import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  /** Shows "Try again", which calls this. The router passes its error boundary's reset (D-048). */
  readonly reset?: () => void;
}

export function UnexpectedError({ reset }: Props) {
  const { t } = useTranslation();
  return (
    <Result
      status="error"
      title={t('app.unexpected_error')}
      extra={
        reset && (
          <Button type="primary" onClick={reset}>
            {t('common.try_again')}
          </Button>
        )
      }
    />
  );
}
